import React from 'react';
import Header from '../navbar/Header';
import Container from '../Container';
import Content from '../Content';
import Navbar from '../navbar/Navbar';
import ServiceList from './ServiceList';
import ServiceForm from './ServiceForm';

function Service() {
    return ( 
        <Container>
            <Navbar/>

            <Content>
                <Header/>

                <div class="container-fluid mt-4">

        <div className='row justify-content-center'>
         <div className='row'>
          
            <ServiceList/>
            </div>
            </div>
            </div>
            </Content>
        </Container>
     );
}

export default Service;